"use strict";
// Copyright 2022 Fergal Daly <fergald@gmail.com>.
Object.defineProperty(exports, "__esModule", { value: true });
exports.n = n;
exports.n2 = n2;
function n(p, n) {
    return String(n).padStart(p, '0');
}
function n2(num) {
    return n(2, num);
}
